<div #container class="absolute top-0 left-40 right-6 z-[999] pt-8">
    <div class="absolute px-6 will-change-transform" [ngClass]="{'transition-transform': !isDragging}"
        (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)"
        [style.transform]="'translate3d(' + calculatedPosition + 'px, 0, 0)'">
        <div #line class="w-[1px] bg-primary" style="height: 100vh;"></div>
    </div>
</div>